var fatHa = require('./fatHa')[0][1];

module.exports = [[[35, -130], fatHa], [[0, -12], fatHa, [-35, 150]]];



/*****************
 ** WEBPACK FOOTER
 ** ../JSCalligrapher/alphabets/abjad/tanwiin.js
 ** module id = 19
 ** module chunks = 0
 **/